__turbopack_context__.v({
  "dock": "social-sidebar-module__EL4TtW__dock",
  "sidebar": "social-sidebar-module__EL4TtW__sidebar",
  "socialLink": "social-sidebar-module__EL4TtW__socialLink",
});
